<template>
    <div class="duels-controls">
        <div class="controls-title">
            <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.90698 20.2069L15.7558 27.0733L13.0174 29.8191L15.7597 32.5668L13.0194 35.3126L8.22287 30.5065L2.74031 36L0 33.2542L5.48256 27.7588L0.686047 22.9546L3.42636 20.2089L6.16667 22.9527L8.90504 20.2069H8.90698ZM1.05814 0L7.93023 0.0058256L30.8314 22.9546L33.5736 20.2089L36.314 22.9546L31.5194 27.7607L37 33.2542L34.2597 36L28.7771 30.5065L23.9806 35.3126L21.2403 32.5668L23.9806 29.8191L1.06395 6.85668L1.05814 0ZM29.0756 0L35.9419 0.0058256L35.9457 6.84697L28.0911 14.7154L21.2384 7.85091L29.0756 0Z" fill="url(#icon-duels-gradient)"/>
                <defs>
                    <linearGradient id="icon-duels-gradient" x1="37" y1="0" x2="-6.31937" y2="10.9114" gradientUnits="userSpaceOnUse">
                        <stop stop-color="var(--accent-yellow)"/>
                        <stop offset="1" stop-color="rgba(255, 138, 0, 0.3)"/>
                    </linearGradient>
                </defs>
            </svg>
            <span>DICE DUELS</span>
        </div>
        <div class="controls-actions">
            <div class="actions-amount">
                <input v-model="duelsAmount" v-on:input="duelsValidateInput" type="text" placeholder="AMOUNT" />
                <IconCoin />
                <div class="amount-buttons">
                    <button v-on:click="duelsSetAmount('clear')">
                        <div class="button-inner">CLEAR</div>
                    </button>
                    <button v-on:click="duelsSetAmount('2x')">
                        <div class="button-inner">2x</div>
                    </button>
                    <button v-on:click="duelsSetAmount('max')" class="button-max">
                        <div class="button-inner">MAX</div>
                    </button>
                </div>
            </div>
            <DuelsFilterCount />
            <button v-on:click="duelsCreateButton" class="button-create">
                <div class="button-inner">CREATE DUEL</div>
            </button>
        </div>
    </div>
</template>

<script>
        import IconCoin from '@/components/icons/IconCoin';
    import { mapGetters, mapActions } from 'vuex';
    import DuelsFilterCount from '@/components/duels/DuelsFilterCount';

    export default {
        name: 'DuelsControls',
        components: {
            DuelsFilterCount,
                IconCoin
        },
        data() {
            return {
                duelsAmount: null
            }
        },
        methods: {
            ...mapActions([
                'notificationShow', 
                'duelsSendCreateSocket'
            ]),
            duelsValidateInput() {
                this.duelsAmount = this.duelsAmount.replace(',', '.').replace(/[^\d.]/g, '');
                this.duelsAmount = this.duelsAmount.indexOf('.') >= 0 ? this.duelsAmount.substr(0, this.duelsAmount.indexOf('.')) + '.' + this.duelsAmount.substr((this.duelsAmount.indexOf('.') + 1), 2).replace('.', '') : this.duelsAmount;
            },
            duelsSetAmount(action) {
                let amount = Math.floor(this.duelsAmount * 100);

                if(action === 'clear') {
                    amount = 0;
                } else if(action === '2x') {
                    amount = Math.floor(amount * 2);
                } else if(action === 'max') {
                    // Balance is stored as $1 = 1, so use directly
                    amount = Math.floor(this.authUser.user.balance * 100);
                }

                this.duelsAmount = parseFloat(amount / 100).toFixed(2);
            },
            duelsCreateButton() {
                if(this.socketSendLoading !== null) { return; }

                if(!this.authenticated) {
                    this.$root.$emit('open-signin-modal-app');
                    return;
                }

                const amount = Math.floor(this.duelsAmount);

                if(amount === null || isNaN(amount) === true || amount <= 0) {
                    this.notificationShow({type: 'error', message: 'Your entered bet amount is invalid.'});
                    return;
                }

                const data = { amount: amount, playerCount: this.duelsFilterCount };
                this.duelsSendCreateSocket(data);
            }
        },
        computed: {
            ...mapGetters([
                'socketSendLoading', 
                'authUser',
                'authenticated',
                'duelsFilterCount'
            ])
        }
    }
</script>

<style scoped>
    .duels-controls {
        width: 100%;
        max-width: 1000px;
        height: 76px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;
        border-radius: 16px;
        background: linear-gradient(135deg, rgba(26, 41, 66, 0.4) 0%, rgba(15, 25, 35, 0.6) 100%);
        border: 2px solid rgba(184, 115, 51, 0.3);
        margin-left: 10px;
        box-sizing: border-box;
        box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.4),
            0 0 20px rgba(184, 115, 51, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
        transition: all 0.3s ease;
    }

    .duels-controls:hover {
        border-color: rgba(184, 115, 51, 0.5);
        box-shadow: 
            0 12px 40px rgba(0, 0, 0, 0.5),
            0 0 30px rgba(184, 115, 51, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.05);
    }

    .duels-controls .controls-title {
        height: 50px;
        display: flex;
        align-items: center;
        gap: 12px;
    }

    .duels-controls .controls-title svg {
        filter: drop-shadow(0 0 8px rgba(184, 115, 51, 0.4));
    }

    .duels-controls .controls-title span {
        font-family: 'Clash Display', sans-serif;
        font-size: 32px;
        font-weight: 700;
        background: var(--gradient-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 1px;
        filter: drop-shadow(0 0 12px rgba(184, 115, 51, 0.3));
    }

    .duels-controls .controls-actions {
        display: flex;
        align-items: center;
    }

    .duels-controls .actions-amount {
        width: 300px;
        height: 50px;
        position: relative;
        margin-right: 20px;
    }

    .duels-controls .actions-amount::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(135deg, rgba(184, 115, 51, 0.15) 0%, rgba(184, 115, 51, 0.05) 100%);
        border-radius: 12px;
        border: 1px solid rgba(184, 115, 51, 0.3);
    }

    .duels-controls .actions-amount input {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        position: absolute;
        top: 1px;
        left: 1px;
        padding: 0 175px 0 48px;
        font-family: 'Satoshi', sans-serif;
        font-size: 14px;
        font-weight: 600;
        color: var(--accent-yellow);
        background: rgba(13, 13, 13, 0.8);
        border-radius: 11px;
        transition: all 0.3s ease;
    }

    .duels-controls .actions-amount input:focus {
        background: rgba(13, 13, 13, 0.95);
        box-shadow: 0 0 0 2px rgba(184, 115, 51, 0.2), inset 0 0 20px rgba(184, 115, 51, 0.1);
    }

    .duels-controls .actions-amount input::placeholder {
        color: rgba(184, 115, 51, 0.4);
        font-weight: 500;
    }

    .duels-controls .actions-amount svg {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translate(0, -50%);
        filter: drop-shadow(0 0 4px rgba(184, 115, 51, 0.3));
        pointer-events: none;
        z-index: 1;
    }

    .duels-controls .amount-buttons {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0, -50%);
    }

    .duels-controls .amount-buttons button {
        min-width: 48px;
        height: 34px;
        margin-right: 8px;
        transition: all 0.3s ease;
    }

    .duels-controls .amount-buttons button.button-max {
        min-width: 52px;
    }

    .duels-controls .amount-buttons button:last-of-type {
        margin-right: 0;
    }

    .duels-controls .amount-buttons button .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        font-family: 'Satoshi', sans-serif;
        font-size: 12px;
        font-weight: 700;
        color: #1a1a1a;
        background: linear-gradient(135deg, rgba(184, 115, 51, 0.9) 0%, rgba(184, 115, 51, 0.7) 100%);
        border-radius: 8px;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }

    .duels-controls .amount-buttons button .button-inner::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
        transition: left 0.5s ease;
    }

    .duels-controls .amount-buttons button:hover .button-inner::before {
        left: 100%;
    }

    .duels-controls .amount-buttons button.button-max .button-inner {
        color: #FFFFFF;
        background: var(--gradient-yellow);
        font-weight: 800;
        box-shadow: 0 4px 15px rgba(184, 115, 51, 0.4);
    }

    .duels-controls .amount-buttons button:hover .button-inner {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(184, 115, 51, 0.3);
    }

    .duels-controls .controls-actions button.button-create {
        width: 140px;
        height: 50px;
        transition: all 0.3s ease;
    }

    .duels-controls .controls-actions button.button-create .button-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Satoshi', sans-serif;
        font-size: 14px;
        font-weight: 800;
        color: #FFFFFF;
        background: var(--gradient-yellow);
        border-radius: 12px;
        box-shadow: 
            0 4px 20px rgba(184, 115, 51, 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
    }

    .duels-controls .controls-actions button.button-create .button-inner::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
        transition: left 0.5s ease;
    }

    .duels-controls .controls-actions button.button-create:hover .button-inner {
        transform: translateY(-2px);
        box-shadow: 
            0 6px 28px rgba(184, 115, 51, 0.6),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
    }

    .duels-controls .controls-actions button.button-create:hover .button-inner::before {
        left: 100%;
    }

    .duels-controls .controls-actions button.button-create:active .button-inner {
        transform: translateY(0);
    }

    @media only screen and (max-width: 1200px) {
        .duels-controls {
            width: 100%;
            max-width: 100%;
            padding: 16px 20px;
            margin-left: 0;
        }

        .duels-controls .controls-title span {
            font-size: 28px;
        }

        .duels-controls .actions-amount {
            width: 280px;
            margin-right: 15px;
        }
    }

    @media only screen and (max-width: 950px) {
        .duels-controls {
            height: auto;
            flex-direction: column;
            align-items: flex-start;
            padding: 14px 16px;
            gap: 12px;
        }

        .duels-controls .controls-title {
            width: 100%;
            justify-content: center;
        }

        .duels-controls .controls-title svg {
            width: 32px;
            height: 32px;
        }

        .duels-controls .controls-title span {
            font-size: 24px;
        }

        .duels-controls .controls-actions {
            width: 100%;
            justify-content: space-between;
            margin-top: 0;
        }

        .duels-controls .actions-amount {
            width: calc(100% - 150px);
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 768px) {
        .duels-controls {
            padding: 14px 16px;
            border-radius: 14px;
        }

        .duels-controls .controls-title {
            justify-content: center;
            margin-bottom: 16px;
        }

        .duels-controls .controls-title svg {
            width: 28px;
            height: 28px;
        }

        .duels-controls .controls-title span {
            font-size: 22px;
        }

        .duels-controls .controls-actions {
            flex-direction: column;
            gap: 12px;
        }

        .duels-controls .actions-amount {
            width: 100%;
            height: 50px;
            margin-right: 0;
        }

        .duels-controls .actions-amount input {
            font-size: 14px;
        }

        .duels-controls .controls-actions button.button-create {
            width: 100%;
            height: 50px;
            font-size: 14px;
            font-weight: 700;
        }
    }

    @media only screen and (max-width: 500px) {
        .duels-controls {
            padding: 12px;
        }

        .duels-controls .controls-title svg {
            width: 24px;
            height: 24px;
        }

        .duels-controls .controls-title span {
            font-size: 18px;
        }

        .duels-controls .actions-amount {
            height: 46px;
        }

        .duels-controls .actions-amount input {
            padding: 0 85px 0 38px;
            font-size: 13px;
        }

        .duels-controls .actions-amount svg {
            width: 18px;
            height: 18px;
            left: 12px;
        }

        .duels-controls .amount-buttons {
            right: 8px;
        }

        .duels-controls .amount-buttons button {
            min-width: 40px;
            height: 32px;
            margin-right: 5px;
        }

        .duels-controls .amount-buttons button .button-inner {
            font-size: 11px;
            padding: 0 6px;
        }

        .duels-controls .amount-buttons button:nth-child(2) {
            display: none;
        }

        .duels-controls .controls-actions button.button-create {
            height: 46px;
            font-size: 13px;
        }
    }

    @media only screen and (max-width: 400px) {
        .duels-controls {
            padding: 10px 12px;
        }

        .duels-controls .controls-title svg {
            width: 22px;
            height: 22px;
        }

        .duels-controls .controls-title span {
            font-size: 16px;
        }

        .duels-controls .actions-amount {
            height: 44px;
        }

        .duels-controls .actions-amount input {
            padding: 0 75px 0 34px;
            font-size: 12px;
        }

        .duels-controls .actions-amount svg {
            width: 16px;
            height: 16px;
            left: 10px;
        }

        .duels-controls .amount-buttons {
            right: 6px;
        }

        .duels-controls .amount-buttons button {
            min-width: 36px;
            height: 30px;
            margin-right: 4px;
        }

        .duels-controls .amount-buttons button .button-inner {
            font-size: 10px;
            padding: 0 5px;
        }

        .duels-controls .controls-actions button.button-create {
            height: 44px;
            font-size: 12px;
        }
    }
</style>
